import React from 'react';
import PropTypes from 'prop-types';
import Client from './Client';

const COMPONENT_MAP = {
  client: Client,
};

function getComponent(resultType) {
  const component = COMPONENT_MAP[resultType];

  if (!component) {
    throw new Error(`Unexpected result type: ${resultType}`);
  }

  return component;
}

const Result = (props) => {
  const {
    searchResultResource,
  } = props;

  const Component = getComponent(searchResultResource.attr('resultType'));

  return (
    <Component {...props} />
  );
};

Result.propTypes = {
  searchResultResource: PropTypes.object.isRequired,
};

export default Result;
